import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { selectUsersForNames } from '../../../store/userSelectors';
import { loadUser } from '../../../store/userService';
import { formatDate, formatTime } from '../../../utils/dateFunctions';

import card from '../../../commonStyles/rowExpand.module.css';

const DarHistory = ({ history }) => {
    const dispatch = useDispatch();

    const [emailAddress, setEmailAddress] = useState('');

    const users = useSelector(selectUsersForNames);

    useEffect(() => {
        if (users?.length < 1) return;
        if (history.userId) {
            const user = users.find((el) => el.id === history.userId);
            user ? setEmailAddress(user.loginEmailAddress) : dispatch(loadUser(history.userId));
        }
    }, [users]);

    return (
        <div className={card.cardView}>
            <div className={card.banner}>
                <span>Email: {emailAddress} </span>
                <span>Date: {formatDate(history.date)}</span>
                <span>Time: {formatTime(history.date)} </span>
                <span>New Status: {history.status}</span>
            </div>

            <div className={card.content}>
                <p>
                    <span className={card.label}>Notes: {` ${history.notes}`}</span>
                </p>
            </div>
        </div>
    );
};

DarHistory.propTypes = {
    history: PropTypes.object
};

export default DarHistory;
